import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import SizeFormModal from "../Sizes/SizeFormModal";
import SizesTable from "../Sizes/SizesTable";

const Sizes = () => {
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchSizes();
  }, []);

  const fetchSizes = async () => {
    try {
      const response = await api.get("/sizes");
      setSizes(response.data);
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/sizes/${id}`);
      setSizes(sizes.filter((size) => size._id !== id));
    } catch (error) {
      console.error("Error deleting size:", error);
    }
  };

  return (
    <div>
      <h1>Manage Sizes</h1>
      <button onClick={() => setIsModalOpen(true)}>Add Size</button>
      <SizesTable
        data={sizes}
        onDelete={handleDelete}
        onEdit={(size) => {
          setSelectedSize(size);
          setIsModalOpen(true);
        }}
      />
      {isModalOpen && (
        <SizeFormModal
          onClose={() => {
            setIsModalOpen(false);
            setSelectedSize(null);
          }}
          onSave={fetchSizes}
          size={selectedSize}
        />
      )}
    </div>
  );
};

export default Sizes;
